import React, { useEffect, useState } from "react";
import {ChevronsUpDown, CircleOff, EllipsisVertical} from "lucide-react";
import { adjustDateTime, can_visit } from "../../helpers";
import SupportStatusModal from "../Modal/SupportStatusModal";
import { useNavigate } from "react-router-dom";
import SingleSupportMessage from "../Section/SingleSupportMessage";
import Skeleton from "react-loading-skeleton";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function SupportDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    handleSupportStatus = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {}
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [viewStatusOptions, setViewStatusOptions] = useState({});
  const [statusData, setStatusData] = useState();
  const [activeStatusModal, setActiveStatusModal] = useState(false);
  const [activeMessage, setActiveMessage] = useState(false);
  const navigate = useNavigate();
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);


  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] === "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    setDataLoading(true);
    reloadData(filter_merge);
  };



  const handleOutsideClick = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setViewStatusOptions({});
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleDropdownClick = (index) => {
    setViewStatusOptions((prev) => {
      const newViewStatusOptions = {};
      newViewStatusOptions[index] = !prev[index];
      return newViewStatusOptions;
    });
  };

  return (
    <>
      {!activeMessage && (
        <div className="docpro_table_responsive custom-scroll" style={{ minHeight: '200px' }}>
          <table className="docpro_mb_0">
            <thead>
              <tr>
                <th>
                  <div
                    onClick={() => { handleOrderChange("created_at"); }}
                    className={
                      orderBy === "created_at" ? "docpro_accent_color" : ""
                    }
                  >
                    <div style={styles}>
                      Created At <ChevronsUpDown size={"12"} />
                    </div>
                  </div>
                </th>
                <th>
                  <div
                    onClick={() => { handleOrderChange("case_id"); }}
                    className={
                      orderBy === "case_id" ? "docpro_accent_color" : ""
                    }
                  >
                    <div style={styles}>
                      Issue ID <ChevronsUpDown size={"12"} />
                    </div>
                  </div>
                </th>
                <th>
                  <div>
                    <div style={styles}>
                    Impact
                    </div>
                  </div>
                </th>
                <th>
                  <div>
                    <div style={styles}>
                    Feature Type 
                    </div>
                  </div>
                </th>
                <th>
                  <div>
                    <div style={styles}>
                      Subject
                    </div>
                  </div>
                </th>
                <th>
                  <div>
                    <div style={styles}>
                    Status
                    </div>
                  </div>
                </th>
                <th>
                  <div>
                    <div style={styles}>
                    Action
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className="pointer">
                    <td onClick={() => {
                      setActiveMessage(true);
                      navigate(`/admin/support/${item.case_id}`, {
                        state: {
                          selectedSupport: item,
                        },
                      });
                      }}>{adjustDateTime(item?.created_at)}</td>
                    <td onClick={() => {
                      setActiveMessage(true);
                      navigate(`/admin/support/${item.case_id}`, {
                        state: {
                          selectedSupport: item,
                        },
                      });
                      }}>{item?.case_id}</td>
                    <td onClick={() => {
                      setActiveMessage(true);
                      navigate(`/admin/support/${item.case_id}`, {
                        state: {
                          selectedSupport: item,
                        },
                      });
                      }}>{item?.impact}</td>
                    <td onClick={() => {
                      setActiveMessage(true);
                      navigate(`/admin/support/${item.case_id}`, {
                        state: {
                          selectedSupport: item,
                        },
                      });
                      }}>{item?.feature_type}</td>
                    <td onClick={() => {
                      setActiveMessage(true);
                      navigate(`/admin/support/${item.case_id}`, {
                        state: {
                          selectedSupport: item,
                        },
                      });
                      }}>{item?.subject}</td>
                    <td onClick={() => {
                      setActiveMessage(true);
                      navigate(`/admin/support/${item.case_id}`, {
                        state: {
                          selectedSupport: item,
                        },
                      });
                      }}>
                      { item?.status ?  <span className="docpro_badge docpro_badge_green">
                          Open
                        </span> :  <span className="docpro_badge docpro_badge_red">
                          Closed
                        </span>}
                    </td>
                    <td className="docpro_text_center">
                      {item?.status && (
                      <div className="docpro_icon_btns">
                        <div className="dropdown-container relative">
                          <button className="docpro_icon_btn" onClick={() => handleDropdownClick(index)}>
                            <EllipsisVertical width={18} height={18} />
                          </button>
                          {viewStatusOptions[index] && (
                            <div className={`docpro_button_toggle_options ${index > 1 && 'top_position'}`}>
                              {(can_visit("settings") && can_visit("settings_users") && can_visit("settings_users_all_users_delete")) && (
                                <button
                                  className="docpro_icon_btn docpro_dropdown_button docpro_icon_btn_red"
                                  onClick={() => {
                                    setStatusData({
                                      account_id: item.account_id,
                                      location_id: item.location_id,
                                      case_id: item.case_id,
                                      status: false
                                    });
                                    setActiveStatusModal(true);
                                    setPreviousScrollPosition(window.scrollY);
                                    window.scrollTo(0, 0);
                                  }}
                                >
                                  <CircleOff width={18} height={18} />
                                  <span>Closed</span>
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "200px" }} colSpan="7">
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5.5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${3 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
            </tbody>
          </table>
        </div>
      )}

      {activeStatusModal && (
        <SupportStatusModal
          handleStatus={() => handleSupportStatus(statusData)}
          activeModal={activeStatusModal}
          setActiveModal={setActiveStatusModal}
          previousScrollPosition={previousScrollPosition}
        />
      )}

      {activeMessage && (
        <SingleSupportMessage/>
      )}
    </>
  );
}
